import { Component, Input } from '@angular/core';
import { PercentPipe } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import Highcharts from 'highcharts';

import { ScreenSizeService } from '../../shared/services/screensize.service';

@Component({
  selector: 'md-portfolio-option',
  template: require('./portfolio-option.component.html'),
  styles: [require('./portfolio-option.component.scss')]
})
export class PortfolioOptionComponent {
  @Input() option;
  subscriptions$: Subscription = new Subscription();
  allocationChart;
  containerId;
  isMobile = false;
  labels = [];

  constructor(screenSize: ScreenSizeService) {
    this.screenSize = screenSize;
  }

  ngOnInit() {
    this.title = this.option.portfolioName;
    this.containerId = this.option.modelPortfolioId.toString();
    this.subscriptions$.add(this.screenSize.resizeSubscription$.subscribe(x => {
      this.onResize(x.width);
    }));
  }

  ngAfterViewInit() {
    // Initialize chart here to make sure the container exists first
    this.initializeChart();
    this.labels = [];
    // Highcharts mutates the array. We need to make a copy.

    const clone = this.option.assetSets.map(x => ({ ...x }));
    this.allocationChart.series[0].setData(clone, true);
    this.allocationChart.reflow();
    this.populateLegend(clone);
    this.onResize(this.screenSize.getWindowSize().width);
  }

  populateLegend(assetSets) {
    const percentPipe = new PercentPipe('en-US');
    assetSets.forEach(item => {
      this.labels.push({
        color: item.className,
        name: `${percentPipe.transform(item.y, '1.0-0')} ${item.name}`
      });
    });
  }

  ngOnDestroy() {
    this.subscriptions$.unsubscribe();
    if (this.allocationChart) {
      this.allocationChart.destroy();
    }
  }

  initializeChart() {
    this.allocationChart = Highcharts.chart({
      credits: {
        enabled: false
      },
      chart: {
        id: 'pieChart',
        plotBackgroundColor: 'transparent',
        plotBorderWidth: 0,
        plotShadow: false,
        renderTo: this.containerId,
        backgroundColor: 'transparent',
        reflow: true,
        marginTop: 15
      },
      legend: {
        enabled: false
      },
      title: {
        text: ''
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        series: {
          pointWidth: 180,
          borderWidth: 2,
          borderColor: '#FFFFFF'
        },
        pie: {
          size: 120,
          dataLabels: {
            enabled: false
          },
          startAngle: -180,
          endAngle: 180,
          borderColor: null,
          showInLegend: false,
          point: {
            events: {
              legendItemClick(e) {
                // prevent legend items from being clicked and omitted from the chart
                e.preventDefault();
              }
            }
          }
        }
      },
      series: [
        {
          type: 'pie',
          name: 'Total Value',
          innerSize: '75%',
          data: [],
          states: {
            hover: {}
          }
        }
      ]
    });
  }

  onResize(width: number) {
    if (!this.allocationChart) {
      return;
    }

    let size,
      chartWidth;

    if (width < 640) {
      size = 120;
      chartWidth = 120;
    } else if (width < 768) {
      size = 150;
      chartWidth = 150;
    } else if (width < 1024) {
      size = 130;
      chartWidth = 130;
    } else {
      size = 150;
      chartWidth = 150;
    }

    this.allocationChart.update({
      chart: {
        width: chartWidth
      },
      plotOptions: {
        pie: {
          size
        }
      }
    }, true, true, false);

    this.allocationChart.reflow();
  }
}
